import { useEffect } from 'react';

import { useCapacitorAppInfo } from '@/hooks/useCapacitorAppInfo';

import type { IMutableContext } from '@unleash/proxy-client-react';

interface Props {
  onSuccess: (properties: IMutableContext['properties']) => void;
}

export const EvaluateCapacitorContext = ({ onSuccess }: Props) => {
  const { data, status } = useCapacitorAppInfo();

  useEffect(() => {
    if (status === 'success') {
      onSuccess({
        nativeAppVersion: data.version,
      });
    }
  }, [data, status, onSuccess]);

  return null;
};
